import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';

export const LeadNotesDialog = ({ lead, onClose, onSave }) => {
  const [notas, setNotas] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => { setNotas(lead?.notas || ''); }, [lead]);

  const handleSave = async () => {
    setSaving(true);
    try { await onSave(notas); } finally { setSaving(false); }
  };

  return (
    <Dialog open={!!lead} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="bg-slate-900 border-white/10 text-white sm:max-w-lg" data-testid="lead-notes-dialog">
        <DialogHeader>
          <DialogTitle>Notas de seguimiento</DialogTitle>
          <DialogDescription className="text-slate-400">
            {lead?.nombre} · {lead?.email}
          </DialogDescription>
        </DialogHeader>
        <Textarea
          data-testid="lead-notes-textarea"
          value={notas}
          onChange={(e) => setNotas(e.target.value)}
          placeholder="Ej: Llamé el lunes, interesado en seguro de viaje a España para agosto..."
          rows={6}
          maxLength={2000}
          className="bg-slate-950 border-white/10 text-white placeholder:text-slate-500 rounded-xl"
        />
        <p className="text-xs text-slate-500 text-right">{notas.length}/2000</p>
        <DialogFooter>
          <Button data-testid="lead-notes-cancel" variant="outline" onClick={onClose} className="rounded-xl border-white/20 bg-transparent text-white hover:bg-white/10 hover:text-white">Cancelar</Button>
          <Button data-testid="lead-notes-save" onClick={handleSave} disabled={saving} className="rounded-xl bg-blue-600 hover:bg-blue-500">
            {saving ? 'Guardando...' : 'Guardar nota'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LeadNotesDialog;
